import React from 'react';

import { TeamsIcon } from '@atlaskit/temp-nav-app-icons/teams';

import { Products } from '../../constants';
import { GlobalShortcutsItem } from '../../types';

export default function teams(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <TeamsIcon size="20" />,
		label: 'Teams',
		apsKey: Products.ATLAS_TEAMS,
		fallbackUrl,
	};
}
